import { sortBy, uniqBy, filter } from 'lodash'

export default {
  applyDiscount(price, discount) {
    return parseFloat(price) * (100 - discount) / 100
  },
  applicablePrices (product, designerTier = { name: null, discount: 0 }) {
    const { price, salePrice, isOnSale, isGiftCard } = product
    const { name: tierName, discount: tierDiscount } = designerTier
    const designerPrice = this.applyDiscount(price, tierDiscount)
    const prices = [
      {
        label: tierName,
        value: designerPrice,
        designerPrice: true,
        display: tierDiscount > 0 && !isGiftCard
      },
      {
        label: 'Sale',
        value: salePrice,
        display: isOnSale
      },
      {
        label: 'Original',
        value: price,
        display: true
      }
    ]
    const filtered = filter(prices, 'display')
    const sorted = sortBy(filtered, ['value', p => p.label === 'Sale' ? 1 : 0])

    return uniqBy(sorted, 'value')
  }
}